<div class='delivery-accelerators-tab-1-part'>
	This is delivery-accelerators-tab-1-part tab 1
</div>